/**
 * FormationAgent — formations themselves are created via the Depth Chart
 * UI. The chat agent simply explains where to go and stays out of the way.
 */

import { isCreateFormationIntent } from './intents';
import type { AgentRunContext, AgentRunResult, CoachSteveAgent } from './types';

export const formationAgent: CoachSteveAgent = {
  name: 'formation',
  description:
    "Tells the user how to save a formation in the Depth Chart. Coach Steve cannot create formations from chat.",
  applicableSports: 'all',
  match: (text) => isCreateFormationIntent(text),
  async handle(_text, ctx: AgentRunContext): Promise<AgentRunResult> {
    ctx.addMessage(
      'assistant',
      "Formations are created in the **Depth Chart**. Go to **Depth Chart** in the menu, pick a unit (e.g. Offense or Defense), set up your positions and players the way you want, then use the **Formations** button to save it as a new formation. I can’t create formations from here — but I can help you add a **player**, create a **practice plan**, **game plan**, or **game** if you’d like."
    );
    return { kind: 'handled' };
  },
};
